import { createContext, useContext, type ReactElement, type ReactNode } from 'react'

export type ActionOptionChoice = { option_type: string; title?: string; reply_body?: string }

/**
 * A page that carries out some of an action card's choices itself (USA-1504): the tax form page
 * opens its own Approve / Reject sheets and its email composer from the card's buttons. It returns the control to show
 * in place of the card's button, built around `trigger` (the card's button, with no click of its
 * own), or undefined to leave that choice to the card.
 */
export type ActionOptionRenderer = (option: ActionOptionChoice, trigger: ReactElement) => ReactNode | undefined

export const ActionOptionContext = createContext<ActionOptionRenderer | null>(null)

export function useActionOptionRenderer(): ActionOptionRenderer | null {
  return useContext(ActionOptionContext)
}
